import { IMFile, HistoryMessageItem, MessageOutgoingEvent, isMessageDeleted } from '@wui/im'
import { computed, readonly, ref, Ref, shallowRef } from 'vue'

import { ChatFile } from '@/shared/types/files'
import { formatMessageText } from '@/shared/utils/text-entities'

const isEditing = computed(() => !!editingMessage.value)
const messageText = ref<string>('')
const editingMessage: Ref<HistoryMessageItem<MessageOutgoingEvent> | null> = shallowRef(null)
const isEditingQuotedMessageRemoved = ref(false)
const originalQuotedEventId = ref<number | undefined>(undefined)
const filesToEdit = ref<IMFile[] | undefined>(undefined)
const isEditingForwardMessageRemoved = ref(false)
const uploadingFilesInEditingMessage: Ref<ChatFile[]> = ref([])

const startEdit = (message: HistoryMessageItem<MessageOutgoingEvent>) => {
  if (isMessageDeleted(message)) {
    return
  }

  const typedMessage = message as HistoryMessageItem<MessageOutgoingEvent>
  originalQuotedEventId.value = typedMessage.item.quote?.quotedEventId
  editingMessage.value = JSON.parse(JSON.stringify(typedMessage))
  messageText.value = formatMessageText(typedMessage.item.messageText, typedMessage.item.entities)
  if (typedMessage.item?.files) {
    filesToEdit.value = typedMessage.item?.files
  }

  if (typedMessage.item.forwarding?.forwardingEventId) {
    messageText.value = formatMessageText(typedMessage.item.messageText, typedMessage.item.entities)
  }
}

const endEdit = () => {
  if (isEditing.value) {
    editingMessage.value = null
    messageText.value = ''
    originalQuotedEventId.value = undefined
    isEditingQuotedMessageRemoved.value = false
    filesToEdit.value = undefined
    uploadingFilesInEditingMessage.value = []
  }
}

const removeEditingMessageQuote = () => {
  if (editingMessage.value?.item.quote?.quotedEventId) {
    isEditingQuotedMessageRemoved.value = true
  }
}

const removeEditingForwardMessage = () => {
  if (editingMessage.value?.item.forwarding?.forwardingEventId && editingMessage.value?.eventId) {
    isEditingForwardMessageRemoved.value = true
  }
}

export function useMessageEdit () {
  return {
    messageText,
    editingMessage,
    startEdit,
    filesToEdit,
    endEdit,
    isEditing: readonly(isEditing),
    removeEditingMessageQuote,
    removeEditingForwardMessage,
    isEditingQuotedMessageRemoved,
    originalQuotedEventId: readonly(originalQuotedEventId),
    isEditingForwardMessageRemoved,
    uploadingFilesInEditingMessage,
  }
}
